import { type TMenuConfig } from './types';

export const MENU_SIDEBAR : TMenuConfig  = [
  {
    title: 'SIDEBAR.DASHBOARDS',
    icon: 'element-11',
    path: '/'
  },
  {
    title: 'SIDEBAR.EXTENSION_BUILDER',
    icon: 'element-plus',
    path: '/extensionbuilder'
  },
  {
    title: 'SIDEBAR.ORDERS',
    icon: 'parcel',
    path: '/orders'
  },
  {
    title: 'SIDEBAR.PACKAGE_BUILDER',
    icon: 'parcel',
    path: '/packagebuilder'
  },
  // {
  //   title: 'Testing Multiple Items',
  //   icon: 'element-11',
  //   children: [
  //     {
  //       title: 'UI Builder',
  //       path: '/dummyfortest/ui-builder'
  //     },
  //     {
  //       title: 'API Builder',
  //       path: '/dummyfortest/api-builder'
  //     },
  //     {
  //       title: 'Settings',
  //       path: '/dummyfortest/settings'
  //     }
  //   ]
  // }
];
